export default {
  'layouts.userLayout.title': 'DocFluxa - 企业级AI智能文档管理系统',

  // 登录页
  'login.accountLogin.tab': '账户密码登录',
  'login.failure': '登录失败，请重试！',
  'login.success': '登录成功！',
  'login.password.expired': '密码过期，请重置密码！',
  'login.password.update.success': '密码更新成功！',
  'login.password.update.fail': '密码更新失败',
  'login.request.fail': '请求失败，请稍后重试',
  'login.password.security': '密码必须包含字母、数字和特殊字符，且长度大于等于8位！',
  'login.contactAdmin': '忘记密码？请联系管理员！',
  'login.alterPassword': '修改密码',
  'login.password.strength.strong': '强度：安全',
  'login.password.strength.medium': '强度：中',
  'login.password.strength.short': '强度：太短',
  'login.password.twice.match': '两次输入的密码不匹配!',
  'login.password.length': '密码长度必须大于等于8位!',
  'login.password.case': '密码必须包含字母、数字和特殊字符!',
  'login.password.diff': '新密码不能与当前密码相同!',
  'login.password.tips': '请至少输入8个字符，并同时包含字母、数字和特殊字符。',
  'login.currentPassword.required': '请输入当前密码!',
  'login.currentPassword.placeholder': '当前密码',
  'login.newPassword.placeholder': '大于等于8位密码，包含字母、数字和特殊字符',
  'login.confirmPassword.required': '请确认密码!',
  'login.confirmPassword.placeholder': '确认密码',
  'login.backToLogin': '使用已有账户登录',
  'login.updatePassword': '更新密码',
  'login.username.placeholder': '用户名',
  'login.username.required': '用户名是必填项！',
  'login.password.placeholder': '密码',
  'login.password.required': '密码是必填项！',
  'login.forgotPassword': '忘记密码 ?',
  'login.forgotPassword.modal.title': '忘记密码',
  'login.forgotPassword.modal.content': '账号【{account}】绑定的邮箱将收到一封重置密码邮件，请登录邮箱完成密码重置操作。',
  'login.forgotPassword.modal.confirm': '确认发送',
  'login.forgotPassword.modal.cancel': '取消',
  'login.forgotPassword.success': '重置密码邮件已发送，请查收！',
  'login.forgotPassword.fail': '发送失败，请稍后重试',

  // 登录页布局文案
  'login.submit': '登录',
  'login.formSubTitle': '请输入您的账号和密码继续',
  'login.leftTitle': '企业智能文档管理平台',
  'login.leftSubTitle': '让知识高效流动，助力团队智能协作',
  'login.feature.docParsing': '智能文档解析与管理',
  'login.feature.ragKnowledge': 'RAG 知识库构建与检索',
  'login.feature.aiQA': 'AI 驱动的内容问答',
  'login.feature.permissionMgmt': '企业级权限管理',
  'login.feature.multiAppIntegration': '多应用集成支持',

  // 修改密码页
  'login.alertPwd.subTitle': '请输入当前密码及新密码',

  // 重置密码页
  'resetPassword.title': '重置密码',
  'resetPassword.subTitle': '请设置您的新登录密码',
  'resetPassword.leftTitle': '重置您的密码',
  'resetPassword.leftSubTitle': '请设置一个安全的新密码，密码需包含字母、数字和特殊字符且长度不少于8位。',
  'resetPassword.account': '账号',
  'resetPassword.submit': '重置密码',
  'resetPassword.success': '密码重置成功，请使用新密码登录！',
  'resetPassword.fail': '重置失败，请重试。',
  'resetPassword.invalidLink': '链接无效或已过期，请重新申请重置密码。',
  'resetPassword.fetchError': '获取账号信息失败，请重试。',
};
